import { render, staticRenderFns } from "./ConfidenceRangeFilter.vue?vue&type=template&id=2f63dd4e&scoped=true"
import script from "./ConfidenceRangeFilter.vue?vue&type=script&lang=js"
export * from "./ConfidenceRangeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63dd4e",
  null
  
)

export default component.exports